module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_2.c6a547e8.png";